import { captureException, captureMessage } from 'error_tracker';

/**
 * Using localStorage but we could enhance to fallback to Cookies later 🍪
 * Usage:
 * ```
 * const storage = new JsonStorage('STORAGE_NAME')
 * storage.save(jsonObject)
 * const value = storage.get()
 * storage.remove()
 * ```
**/
export default class JsonStorage {
	constructor (name) {
		this.name = name;
		return this;
	}

	get = () => {
		let value = localStorage.getItem(this.name);
		try {
			let val = JSON.parse(value);
			return val;
		} catch (e) {
			// its bad data, get rid of it
			captureException(e);
			captureMessage(`Bad data for JsonStorage item ${name}`);
			this.remove();
			return;
		}
	}

	save = (value) => {
		if (!value) return;
		localStorage.setItem(this.name, JSON.stringify(value));
	}

	remove = () => {
		localStorage.removeItem(this.name);
	}
}
